import OapTableOfContents from './code/Scripts/Components/OapTableOfContents.vue';

export default {
  components: {
    OapTableOfContents,
  },
};
